<template>
  <div class="flex flex-col overflow-auto w-full">
    <div class="space-y-2 w-full divide-y divide-mid-neutral-50">
      <OxfordLevelOfEvidencePlan />
      <AppraisalCriteria />
    </div>
  </div>
</template>

<script setup lang="ts">
import OxfordLevelOfEvidencePlan from './OxfordLevelOfEvidencePlan.vue'
import AppraisalCriteria from './AppraisalCriteria.vue'
</script>
